import { createSelector } from '@reduxjs/toolkit';

import { IBboxSchema } from 'shared/repositories/commercial-listing-map/entities/bbox/BboxSchema';
import { convertMapBoundsToBbox } from 'shared/utils/map/convertMapBoundsToBbox';

import { useReduxSelector } from '../../../external/hooks';

import { mapSelectedBoundsSelector } from './dumb';

export const mapSelectedBboxSelector = createSelector(mapSelectedBoundsSelector, selectedBounds => {
  return selectedBounds ? convertMapBoundsToBbox(selectedBounds) : undefined;
});

export function useMapSelectedBboxSelector(): IBboxSchema | undefined {
  return useReduxSelector(mapSelectedBboxSelector);
}
